<template>
    <div id="app" ref="my_body">
        <Header/>
        <router-view/>
    </div>
</template>


<style lang="scss">
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    @import "../public/sass/main";

</style>

<script>
    import Header from '@/components/Header'

    export default {
        name: 'home',
        components: {
            Header
        },
        methods: {

        },
        mounted() {

        },
        created() {

        }

    }


</script>
